/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
} from 'data/template/template.types';
import { DeliveryFunctionNetworkInterface } from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode:'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  dfnInterfaces: DeliveryFunctionNetworkInterface[],
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptTemplateFieldChanges(
  template: FormTemplate,
  fieldName: string,
  value: string,
  ): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  return clonedTemplate;
}
